import React, { useMemo, useState } from 'react';

function CustomerDirectory({ appointments, onDeleteAppointment, onSelectDate }) {
  const [searchTerm, setSearchTerm] = useState('');

  const allAppointments = useMemo(
    () =>
      Object.entries(appointments)
        .flatMap(([date, customers]) =>
          customers.map((customer, index) => ({
            ...customer,
            date,
            index,
            id: `${date}-${index}`,
          }))
        )
        .sort((a, b) => a.date.localeCompare(b.date)),
    [appointments]
  );

  const filteredAppointments = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) {
      return allAppointments;
    }
    return allAppointments.filter((item) => {
      return (
        item.name.toLowerCase().includes(term) ||
        item.address.toLowerCase().includes(term) ||
        (item.serviceType || 'Standard clean').toLowerCase().includes(term) ||
        item.date.includes(term)
      );
    });
  }, [allAppointments, searchTerm]);

  return (
    <div className="customer-directory">
      <div className="day-panel-header">
        <h2>Customer directory</h2>
        <p>All appointments are shown here so your mom can review customers, payments, and service type.</p>
      </div>
      <div className="search-bar">
        <input
          type="search"
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          placeholder="Search by customer, address, service type, or date"
        />
      </div>
      {filteredAppointments.length === 0 ? (
        <p className="empty-state">No matching appointments. Try another search or add a new appointment.</p>
      ) : (
        <div className="directory-grid">
          {filteredAppointments.map((item) => (
            <div key={item.id} className="customer-card">
              <div className="customer-card-title">
                <strong>{item.name}</strong>
                <span>{item.payment ? `$${item.payment}` : 'No price'}</span>
              </div>
              <div>{item.address}</div>
              <div>Service: {item.serviceType || 'Standard clean'}</div>
              <div>House size: {item.size || 'N/A'}</div>
              <div>Scheduled date: {item.date}</div>
              {item.notes && <div className="notes">Notes: {item.notes}</div>}
              <div className="appointment-actions">
                {onSelectDate && (
                  <button type="button" className="button-small" onClick={() => onSelectDate(item.date)}>
                    View day
                  </button>
                )}
                {onDeleteAppointment && (
                  <button type="button" className="button-small delete" onClick={() => onDeleteAppointment(item.date, item.index)}>
                    Delete
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomerDirectory;
